<mat-nav-list *ngFor="let item of item.root | menu:true">
  <a mat-list-item [routerLinkActive]='["link-active"]' [routerLink]='[item.routerLink]' >
    <mat-icon [svgIcon]="item.icon"></mat-icon>
    <span translate>{{item.description}}</span>
  </a>
</mat-nav-list>
<div class="margin-right-2">
<mat-accordion *ngFor="let item of item.root | menu:false;  let i = index">
  <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span translate>{{item.description}}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-menu-item [item]="item" [permissions]="permissions"></app-menu-item>
  </mat-expansion-panel>
</mat-accordion>
</div>
